module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range-selector"
  }, [_c('vue-slider', {
    ref: "slider",
    staticClass: "range-selector__slider",
    attrs: {
      "piecewise": false,
      "width": "270px",
      "height": 6,
      "interval": _vm.interval,
      "dotSize": 12,
      "min": this.attribute.min,
      "max": this.attribute.max,
      "disabled": false,
      "show": true,
      "tooltip": "always",
      "tooltipDir": ['top', 'top'],
      "bgStyle": _vm.bgStyle,
      "sliderStyle": [_vm.sliderStyle, _vm.sliderStyle],
      "tooltipStyle": [_vm.tooltipStyle, _vm.tooltipStyle],
      "processStyle": _vm.processStyle,
      "labelStyle": _vm.labelStyle,
      "formatter": _vm.formatString,
      "clickable": false
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "range-selector__submit-button",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('svg-icon', {
    attrs: {
      "width": "16px",
      "height": "16px",
      "icon": _vm.Check
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecf61d74","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/RangeSlider.vue
// module id = 2180
// module chunks = 0